module.exports = __webpack_public_path__ + "img/iconlibrary.80830b91.svg";